// extracted by mini-css-extract-plugin
export default {"sliderLabel":"App_sliderLabel__450O-","buttonsContainer":"App_buttonsContainer__mkYvh","optionsButton":"App_optionsButton__vhazM"};